import { render, staticRenderFns } from "./ComposantePrix.vue?vue&type=template&id=661af3ad&"
import script from "./ComposantePrix.vue?vue&type=script&lang=js&"
export * from "./ComposantePrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661af3ad')) {
      api.createRecord('661af3ad', component.options)
    } else {
      api.reload('661af3ad', component.options)
    }
    module.hot.accept("./ComposantePrix.vue?vue&type=template&id=661af3ad&", function () {
      api.rerender('661af3ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menus/ComposantePrix.vue"
export default component.exports